@import "@/scss/use-bootstrap-mixins";

.stack_desktop {
  display: none;
  @include media-breakpoint-up(lg) {
    display: flex;
    min-height: 400px;
    gap: 20px;
    justify-content: center;
  }

  .card_wrapper {
    width: 420px;
  }

  .selected {
    transform: translate(0, -190px);
  }

  .card {
    flex-grow: 1;
    border-radius: 14px;
    padding: 21px;
    color: $textColorOnPrimary !important;
    width: 420px;
    height: 100%;
    // transition: all 0.2s;
    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;

      .deal_title {
        margin-top: 4px;
        font-size: 14px;
      }

      .first {
        text-align: left;

        label {
          line-height: 110%;
          // padding-bottom: 4px;
        }

        span:nth-child(1) {
          font-size: 18px;
          margin: 0;
          color: $textColorOnPrimary !important;
        }
      }

      .last {
        text-align: right;
        min-width: 130px;

        > span:nth-child(1) {
          font-size: 18px;
          margin: 0;
          color: $textColorOnPrimary !important;
          text-align: right !important;
          display: block;
        }

        > span:nth-child(2) {
          font-size: 10px;
          font-weight: 500;
          // opacity: 0.7;
          color: $textColorOnPrimary !important;
        }
      }

      .deal_copy {
        padding: 4px 0 10px 0;
      }

      .custom_format {
        span {
          display: block !important;
          font-size: 12px;
        }
      }

      .savings_badge {
        background-color: $shade2;
        padding: 1px 4px;
        border-radius: 40%;
        opacity: 1 !important;
        margin-left: 4px;
        font-size: 10px;
      }
    }

    .descriptionsInclusions {
      font-size: 13px;
      font-weight: 600;
    }

    .description {
      display: flex;
      // margin-top: 22px;
      margin-bottom: 32px;
      // flex-direction: column;
      flex-wrap: wrap;
      width: 100%;

      .inclusion {
        width: 50%;
        display: flex;
        padding-right: 5px;
        align-items: center;

        .tick {
          svg {
            width: 13px;
            height: 9px;
            margin-right: 13px;
          }
        }

        .text {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    // .button {
    //     background-color: #fff;
    //     color: #000;
    //     border-radius: 14px;
    //     padding: 14px;
    //     border: 0;
    //     width: 100%;
    //     font-size: 16px;
    //     font-weight: 500;
    //     margin-bottom: 19px;

    //     &:hover {
    //         cursor: pointer;
    //     }
    // }
  }
}

.stack {
  // position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  // background-color: $base;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;

  @include media-breakpoint-up(lg) {
    display: none;
  }

  .card {
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    padding: 18px 21px;
    color: $textColorOnPrimary;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-animation-duration: 0.4s;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-iteration-count: 1;
    transition: height 0.4s;
    overflow: hidden;

    &:last-child {
      .button {
        margin-bottom: 10px;
      }
    }

    @include media-breakpoint-up(lg) {
      padding: 30px 21px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;

      .deal_title {
        // margin-top: 4px;
        font-size: 14px;
      }

      .first {
        text-align: left;

        label {
          line-height: 110%;
          // padding-bottom: 4px;
        }

        span:nth-child(1) {
          font-size: 18px;
          font-weight: 500;
          margin: 0;
          color: $textColorOnPrimary !important;
        }

        span:nth-child(2) {
          font-size: 12px;
        }
      }

      .last {
        text-align: right;
        min-width: 130px;

        > span:first-child {
          font-size: 18px;
          font-weight: 500;
          color: $textColorOnPrimary !important;
          margin: 0;
          text-align: right !important;
          display: block;
        }

        > span:nth-child(2) {
          font-size: 11px;
          font-weight: 500;
          color: $textColorOnPrimary !important;
          opacity: 0.7;
        }
      }

      .savings_badge {
        background-color: $shade2;
        padding: 1px 4px;
        border-radius: 40%;
        opacity: 1 !important;
        margin-left: 4px;
        font-size: 10px;
      }
    }

    .descriptionsInclusions {
      font-size: 13px;
      font-weight: 600;
    }

    .description {
      display: flex;
      margin-top: 8px;
      margin-bottom: 32px;
      // flex-direction: column;
      flex-wrap: wrap;
      width: 100%;

      .inclusion {
        width: 50%;
        display: flex;
        padding-right: 5px;

        .tick {
          svg {
            width: 13px;
            height: 9px;
            margin-right: 13px;
          }
        }

        .text {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }

    .button {
      background-color: #fff;
      color: #000;
      border-radius: 14px;
      padding: 14px;
      border: 0;
      width: 100%;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.fadeOut {
  transition: all 0.4s ease !important;
  opacity: 0 !important;
}

.fadeIn {
  transition: all 0.4s ease !important;
  opacity: 0.7 !important;
}

.expandedCard {
  height: calc(100vh - 81px) !important;
  z-index: 5 !important;
}

.card_0 {
  background-color: $primary;
  z-index: 0;
}

.card_1 {
  background-color: $shade1;
  z-index: 1;
}

.card_2 {
  background-color: $shade2;
  z-index: 2;
}

.underline {
  border-bottom: 2px solid $textColorOnPrimary;
  // line-height: 2;
}

.callNowLink {
  text-align: center !important;
  display: block;
  font-size: 16px;
  margin-top: 4px;
  color: $textColorOnPrimary !important;
}

.click_to_view {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 2px;
  font-size: 11px;

  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.clickFadeOut {
  transition: all 0.4s ease !important;
  opacity: 0 !important;
  height: 0;
}

.clickFadeIn {
  transition: all 0.4s ease !important;
  opacity: 0.7 !important;
  height: auto;
}
